var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTaskMicro = function SvgTaskMicro(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#349FD1",
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20 9.25A4.75 4.75 0 0 0 15.25 14v4a4.75 4.75 0 1 0 9.5 0v-4A4.75 4.75 0 0 0 20 9.25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.75 18a.75.75 0 0 0-1.5 0 8.75 8.75 0 0 0 8 8.718v2.235q-.325.043-.645.123l-.787.196a.75.75 0 0 0 .364 1.456l.787-.197a4.25 4.25 0 0 1 2.062 0l.787.197a.75.75 0 0 0 .364-1.456l-.787-.196a6 6 0 0 0-.645-.123v-2.235a8.75 8.75 0 0 0 8-8.718.75.75 0 0 0-1.5 0 7.25 7.25 0 1 1-14.5 0"
  })));
};
export { SvgTaskMicro as ReactComponent };